// npm
import React from 'react'
import PropTypes from 'prop-types'

// react
import { SingleLineTextEditor } from 'components/presentation/text_editors/single_line'
import { DisableAnsweringContext } from 'components/pages/exam/disabled-context'


class ShortTextAnswerForm extends React.Component
{
	render()
	{
		const props = {
			value: this.props.value || '',
			disabled: this.context,
			onChange: this.props.onChange,
		};

		return <SingleLineTextEditor {...props}/>;
	}
}

ShortTextAnswerForm.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
};

ShortTextAnswerForm.contextType = DisableAnsweringContext;


export { ShortTextAnswerForm }
